import React from 'react';

export default function DragHProxy() {
    return (
        <div
            id="proxy"
            style={{
                left: '-999px',
                height: '50px',
                width: '225px',
                padding: '10px',
                position: 'absolute',
                border: '1px solid purple',
                backgroundColor: 'lightblue',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            }}
        >
            Dragging...
        </div>
    );
}
